// Module
var code = "<div class=\"field\">\r\n  <label class=\"label\">LabelText</label>\r\n  <div class=\"control\">\r\n    <div class=\"select is-fullwidth\">\r\n      <select></select>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
// Exports
module.exports = code;